import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { MatDialog } from '@angular/material/dialog';
import { ActionDialogComponent } from '../../../shared-components/action-dialog/action-dialog.component';
import { Router } from '@angular/router';
import {
  Client,
  OpportunityResponse,
} from '../../../models/suggestion-engine-models';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-top5',
  templateUrl: './top5.component.html',
  styleUrls: ['./top5.component.scss'],
  imports: [NgxLoadingModule, MatCardModule],
})
export class Top5Component implements OnInit {
  private ses = inject(SuggestionEngineService);
  private dialog = inject(MatDialog);
  private router = inject(Router);

  clientOpts: Client[] = [];
  state: string = 'loaded';

  ngOnInit() {
    this.ses.getTop5().subscribe((x: OpportunityResponse) => {
      this.clientOpts = x.opportunities.clients;
    });
  }

  dailyAction(type, id, bridge) {
    if (type === 'like') {
      const dialogRef = this.dialog.open(ActionDialogComponent, {
        panelClass: 'action-dialog',
        data: { action: 'like', id: id, bridge: bridge },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.ses
          .takeDailyAction(id, result.data.type, bridge)
          .subscribe((x: OpportunityResponse) => {
            this.clientOpts = x.opportunities.clients;
          });
      });
    } else {
      this.ses
        .takeDailyAction(id, 2290, bridge)
        .subscribe((x: OpportunityResponse) => {
          this.clientOpts = x.opportunities.clients;
        });
    }
  }

  noBridgeAction(id) {
    const opp = this.clientOpts.find(z => z.id === id);

    if (opp && opp.action?.length > 0) {
      return false;
    }
    return true;
  }

  goToProfile(ev, id) {
    this.router.navigate([`/se/client/${id}`]);
  }
}
